<template>
  <div>
    <call-me-en v-if="currentLang.value == 'en'"></call-me-en>
    <call-me-cn v-else></call-me-cn>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'
import CallMeCn from './modules/callMe_cn.vue'
import CallMeEn from './modules/callMe_en.vue'

export default {
  components: {
    CallMeCn,
    CallMeEn,
  },

  data() {
    return {
      
    };
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    ...mapState([
      'langs'
    ]),
  },

  mounted() {
    
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/callMe/index.vue